module.exports = __webpack_public_path__ + "static/img/financial_tab.1aa7d16c.png";